import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 md:py-24 bg-brand-dark" data-id="element-121">
      <div className="container mx-auto px-4" data-id="element-122">
        <div className="max-w-3xl mx-auto text-center" data-id="element-123">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex flex-col items-center" data-id="element-124">
            <ShieldCheck className="w-16 h-16 md:w-20 md:h-20 text-brand-light mb-6" data-id="element-125" />

            <h2 className="text-2xl md:text-4xl font-bold mb-8 font-[Poppins,_sans-serif]" data-id="element-126">
              GARANTÍA 14 DÍAS — SIN PREGUNTAS
            </h2>

            <div className="w-full border-2 border-brand-green/40 rounded-2xl p-8 md:p-12 mb-6" data-id="element-127">
              <p className="text-base md:text-lg text-gray-300 mb-4" data-id="element-128">
                Abrís los tomos. Seguís el protocolo.
              </p>
              <p className="text-base md:text-lg text-gray-300 mb-6" data-id="element-129">
                Si en 14 días no es lo que esperabas:
              </p>
              <p className="text-3xl md:text-4xl font-bold text-brand-light mb-3 font-[Poppins,_sans-serif]" data-id="element-130">
                Devolución del 100%
              </p>
              <p className="text-lg md:text-xl font-bold text-white" data-id="element-131">
                sin formularios, sin drama.
              </p>
            </div>

            <p className="text-sm text-gray-400" data-id="element-132">
              Tasa de devoluciones: menos del 1%.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}